document.addEventListener('DOMContentLoaded', function () {
  // 明示的に遅延処理でDOM安定を待つ（念のため）
  setTimeout(function () {
    if (window.innerWidth < 768) {
      document.querySelectorAll('.footer-menu__item.has-children > .footer-menu__link').forEach(function (link) {
        // 既にバインドされている場合はスキップ（2重防止）
        if (link.dataset.bound === 'true') return;

        link.addEventListener('click', function (e) {
          const parent = link.closest('.footer-menu__item');

          if (!parent.classList.contains('has-children')) return;

          e.preventDefault(); // 子あり：リンク無効化

          // アコーディオンの開閉制御
          const isOpen = parent.classList.contains('is-open');
          if (isOpen) {
            parent.classList.remove('is-open');
          } else {
            document.querySelectorAll('.footer-menu__item.is-open').forEach(function (item) {
              item.classList.remove('is-open');
            });
            parent.classList.add('is-open');
          }
        });

        // フラグを付けて、2回以上バインドされないように
        link.dataset.bound = 'true';
      });
    }
  }, 50); // 少しだけ遅延（DOMの安定化のため）
});
